module.exports = "https://static.energy5.com/_next/static/images/mediumDecor-1cc2b64147060dc802d7d53d74750538.png";